import { onMounted, onBeforeUnmount } from 'vue';
import { swipeEnd, swipeMove, swipeStart } from '@/js/swipe';

export default function usePullDown(el) {
  function initPullDown() {
    el.value.addEventListener('touchstart', swipeStart, false);
    el.value.addEventListener('touchmove', swipeMove, false);
    el.value.addEventListener('touchend', swipeEnd, false);
  }

  function removePullDown() {
    el.value.removeEventListener('touchstart', swipeStart);
    el.value.removeEventListener('touchmove', swipeMove);
    el.value.removeEventListener('touchend', swipeEnd);
  }

  onMounted(() => {
    initPullDown();
  });

  onBeforeUnmount(() => {
    removePullDown();
  });

  return {};
}
